export default function AcademyOverview() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Image */}
        <div className="relative">
          <img
            src="/assets/images/site/acad-overview-001-800x700.jpg"
            alt="Harambee Trading Academy overview futures trading education Africa"
            className="w-full h-[520px] object-cover object-top rounded-lg"
          />
          {/* Floating card */}
          <div className="absolute -bottom-6 -right-6 bg-[#1A4D3C] text-white rounded-lg p-6 max-w-[220px] hidden md:block">
            <div className="font-['Cormorant_Garamond'] text-4xl font-bold text-[#C9A961] mb-1">2024</div>
            <div className="text-white/70 text-xs leading-relaxed">Nairobi Academy Launch &mdash; Empowering the next generation of disciplined investors</div>
          </div>
        </div>

        {/* Content */}
        <div>
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            About the Academy
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            A Trusted Training Environment for Serious Learners
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-5">
            The Harambee Trading Academy is the educational cornerstone of Harambee Global Ventures &mdash; an international platform dedicated to empowering the African Diaspora through innovative pathways to intergenerational wealth creation.
          </p>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
            We believe that financial education is a foundation, not a shortcut. Our academy is built on the principles of market literacy, trading discipline, and long-term investor readiness. Whether you are just beginning your financial journey or seeking to deepen your market knowledge, our structured programs provide the clarity and confidence to move forward with purpose.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {[
              { icon: "ri-book-open-line", title: "Structured Curriculum", desc: "Carefully designed learning pathways from fundamentals to advanced concepts" },
              { icon: "ri-shield-star-line", title: "Credible & Disciplined", desc: "No hype, no promises &mdash; just rigorous, honest financial education" },
              { icon: "ri-earth-line", title: "Cross-Border Perspective", desc: "Global market context tailored for African and diaspora investors" },
              { icon: "ri-community-line", title: "Community-Centered", desc: "Learn alongside a network of like-minded peers and mentors" },
            ].map((item) => (
              <div key={item.title} className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 flex-shrink-0 mt-0.5">
                  <i className={`${item.icon} text-[#1A4D3C] text-base`} />
                </div>
                <div>
                  <div className="font-semibold text-[#2B2D2F] text-sm mb-1">{item.title}</div>
                  <div className="text-[#6B6B6B] text-xs leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
